import { authHeader } from './supabase';
export async function llamarARIA(prompt, opts = {}) {
  const response = await fetch("/api/aria", {
    method: "POST",
    headers: { ...(await authHeader()), "Content-Type": "application/json" },
    body: JSON.stringify({
      messages: [{ role: "user", content: prompt }],
      ...(opts.system ? { system: opts.system } : {}),
      ...(opts.model ? { model: opts.model } : {}),
      ...(opts.max_tokens ? { max_tokens: opts.max_tokens } : {}),
    }),
  });
  const data = await response.json();
  const raw = data.content?.[0]?.text || "";
  return raw.replace(/```json/g,"").replace(/```/g,"").trim();
}
